module.exports = __webpack_public_path__ + "static/media/user_icon_reseller_yl.23a7076e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_icon_reseller_yl.svg
// module id = 113
// module chunks = 0